module.exports = __webpack_public_path__ + "img/notify-popup-base.1ed1d777.svg";